import { render, staticRenderFns } from "./playgame.vue?vue&type=template&id=286f09bc&scoped=true&"
import script from "./playgame.vue?vue&type=script&lang=js&"
export * from "./playgame.vue?vue&type=script&lang=js&"
import style0 from "./playgame.vue?vue&type=style&index=0&id=286f09bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286f09bc",
  null
  
)

export default component.exports